export function adress(id) {
  if (!id) return ''
  if (id == 1)
    return 'Пензенская область, Мокшанский район, с. Нечаевка, РСК «Голодяевский»'
  else if (id == 12)
    return 'Курская область, Поныровский р-он, д. Горяйново, РСК «Камень»'
  else if (id == 10)
    return 'Курская область, Курский р-н, д. Нижнекасиново, РСК «Стадион»'
  else if (id == 2) return 'Республика Адыгея, ст-ца Кужорская, РСК «Кужора»'
  else if (id == 17) return 'Кемеровская область, Кемерово, д.Береговая'
  else if (id == 3)
    return 'Краснодарский край, Выселковский район, Березанское сельское поселение, посёлок Заречный, РСК «Клондайк»'
  else if (id == 19) return 'Калужская область, Мещевский район, д. Лошиха'
  else return ''
}
